import {createColumnHelper} from "@tanstack/react-table";
import CustomerTableAction from "../../views/customers/CustomerTableAction";
import Card from "../../components/UI/Card";
import Table from "../../components/UI/Table";
import {getCustomers} from "../../api/customers";
import Button from "../../components/UI/Button";
import {Link} from "react-router-dom";
import {checkPermission} from "../../util/auth";
import {useNavigate} from "react-router";
import {useEffect} from "react";

const CustomerList = ()=> {
    const navigate = useNavigate();
    useEffect(() => {
        if (!checkPermission(['CUSTOMER_READ'])) {
            navigate("/no-access");
        }
    }, [navigate]);
    const columnHelper = createColumnHelper();
    const columns = [
        columnHelper.accessor('name', {
            id: 'name',
            header: 'Name'
        }),
        columnHelper.accessor('username', {
            id: 'username',
            header: 'Username'
        }),
        columnHelper.accessor('phone', {
            id: 'phone',
            header: 'Phone'
        }),
        columnHelper.accessor('email', {
            id: 'email',
            header: 'Email'
        }),
        columnHelper.accessor('created_at', {
            id: 'created_at',
            header: 'Create Date'
        }),
        /*columnHelper.accessor('last_order', {
            id: 'last_order',
            header: 'Last Order Date'
        }),*/
        columnHelper.accessor('last_login', {
            id: 'last_login',
            header: 'Last Login'
        }),
        columnHelper.display( {
            id: 'count',
            header: "Order",
            cell: props =><>{checkPermission(['ORDER_READ']) ? <Link to={'/orders'}> <Button text={props.row.original.count}  className={"btn btn_sm btn_black"} size={'btn_sm has_border_radius'} /></Link> : <Button text={props.row.original.count}  className={"btn btn_sm btn_black"} size={'btn_sm has_border_radius'} />}</>
        }),

        columnHelper.display( {
            id: 'actions',
            header: "Actions",
            classes:'text_right',
            cell: props => <CustomerTableAction id={props.row.original.id} />
        }),
    ];
    return (
        <>
            <Card title={"Customers"}>
                <Table
                    queryKey={"customers"}
                    columns={columns}
                    queryParams={{per_page: 10}}
                    queryFn={getCustomers}
                ></Table>
            </Card>
        </>
    )
}

export default CustomerList